import "./vendor/modernizr";
import jquery from 'jquery';
import "bootstrap-input-spinner";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "@chenfengyuan/datepicker";
import "jquery-match-height";
import "jquery-bootstrap-scrolling-tabs";
import lineClamp from "line-clamp";
import "select2";
import "chart.js";
import moment from "moment";
import "datatables.net";
import "./vendor/datetime-moment";
import "trumbowyg";
import { driver } from "driver.js";
//import alert from 'bootstrap';
//import button from 'bootstrap';
//import carousel from 'bootstrap';
import _collapse from "bootstrap";
//import dropdown from 'bootstrap';
//import modal from 'bootstrap';
//import popover from 'bootstrap';
//import scrollspy from 'bootstrap';
import _tab from "bootstrap";
//import toast from 'bootstrap';
//import tooltip from 'bootstrap';
//import util from 'bootstrap';

import Validation from "./components/validation";
import Pods from './components/trillium.components.pods';
import ChartsJS from './components/trillium.components.charts';
/*import Tables from './components/tables';*/

const Site = {};

window.$ = jquery;
window.jQuery = jquery;
window.moment = moment;
window.driver = driver;

$(document).ready(() => {
    Site.vars = {
        window: $(window),
        document: $(document),
        body: $("body"),
        htmlBody: $("html, body")
    };

    const s = Site.vars;
    s.windowWidth = s.window.width();
    s.windowHeight = s.window.height();
    s.pods = $('.podRow');
    s.chartjs = $('.chartjs');

    Validation(s);
    Pods(s);
    ChartsJS(s);

    // Datepickers
    $('[data-toggle="datepicker"]').datepicker({
        format: "dd/mm/yyyy"
    });

    var today = new Date();
    $('[data-toggle="datepicker-past"]').datepicker({
        format: "dd/mm/yyyy",
        endDate: today
    });

    //input spinner
    $(".inputSpinner").inputSpinner(
        {
            buttonsClass: "btn btn-primary",
            template: // the template of the input
                '<div class="input-group ${groupClass}">' +
                '<div class="d-inline-block"><button style="min-width: ${buttonsWidth}" class="btn fakeSquare btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button></div>' +
                '<input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control fakeRect form-control-text-input d-inline-block mlr-20"/>' +
                '<div class="d-inline-block"><button style="min-width: ${buttonsWidth}" class="btn fakeSquare btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button></div>' +
                '</div>'
        }
    );

    // Same Height:
    $(function () {
        $('.matchHeightClass').matchHeight();
    });

    if (window.TrilliumMvcActionAsyncLoader !== undefined) {
        TrilliumMvcActionAsyncLoader.init();
    }

    if (window.TrilliumFormHelpers !== undefined) {
        TrilliumFormHelpers.init();
    }

    if (window.TrilliumLookupsCraftyClicks !== undefined) {
        TrilliumLookupsCraftyClicks.init();
    }

    if (window.TrilliumPersonalisationSimulator !== undefined) {
        TrilliumPersonalisationSimulator.init();
    }

    if (window.TrilliumFundRaisingCampaign !== undefined) {
        TrilliumFundRaisingCampaign.init();
    }

    if (window.TrilliumConfirmationModal !== undefined) {
        TrilliumConfirmationModal.init();
    }

    if (window.initTablesFunctions !== undefined) {
        initTablesFunctions.start();
    }

    if (window.datePickersFunctions !== undefined) {
        datePickersFunctions.init();
    }

    // Horizontal Nav Bar
    $('.nav-tabs').scrollingTabs({
        bootstrapVersion: 4,
        cssClassLeftArrow: 'fas fa-chevron-left',
        cssClassRightArrow: 'fas fa-chevron-right'
    });

    // Because IE doesn't support line-clamping
    $(function () {
        var podsBody = $(".card-text");

        if (podsBody !== undefined && podsBody.length > 0) {
            $(podsBody).each(function () {
                var element = $(this).find("p")[0];
                if (element !== undefined) {
                    lineClamp(element, 5);
                }
            });
        }
    });

    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) s.body.css("cursor", "pointer");

    // My addresses
    $("#Address_Wrapper, #ApplicationLandingWrapper").on("click", ".deleteAddress", function () {
        var addressParent = $(this).parent().closest(".address_Entity");
        var editView = addressParent.find(".editAddressView").first();
        var deleteView = addressParent.find(".deleteAddressView").first();

        $(editView).fadeOut(500, function () {
            $(deleteView).fadeIn(500, function () { });
        });
    });

    $("#Address_Wrapper, #ApplicationLandingWrapper").on("click", ".cancelDeleteAddress", function () {
        var addressParent = $(this).parent().closest(".address_Entity");
        var editView = addressParent.find(".editAddressView").first();
        var deleteView = addressParent.find(".deleteAddressView").first();

        $(deleteView).fadeOut(500, function () {
            $(editView).fadeIn(500, function () { });
        });
    });

    // cancel button deselects all checkboxes
    $(".page-wrapper").on("click", ".deselect-checked-trainees", function () {
        $(':checkbox.pendingTraineeList').each(function () {
            $(this).prop('checked', false);
            $(this).change();
        });

        var selectAll = $('.select-all-pending-trainees');
        if (selectAll.length) {
            selectAll.prop('checked', false);
        }
    });

    // select all checkbox
    $(".page-wrapper").on("click", ".select-all-pending-trainees", function () {
        if ($(this).is(":checked")) {
            $(':checkbox.pendingTraineeList').each(function () {
                $(this).prop('checked', true);
                $(this).change();
            });
        }
        else {
            $(':checkbox.pendingTraineeList').each(function () {
                $(this).prop('checked', false);
                $(this).change();
            });
        }
    });

    // checkbox
    //Group Select
    $(".page-wrapper").on("change", ".groupList", function () {
        var GroupList = "";
        $(".groupList:checked").each(function () {
            var GroupId = $(this).data("group-id");
            if (GroupId != null && GroupId != undefined) {
                GroupList += GroupId + ",";
            }
        });
        GroupList = GroupList.slice(0, -1);
        $('.SelectedGroupIds').val(GroupList);
    });

    // TSA/TPA select
    $(".page-wrapper").on("change", ".resultsSelect", function () {

        var count = 0;

        $(".resultsSelect:checked").each(function () {

            count += 1;
        });

        if (count > 0) {
            $(".addRemoveSubmit").prop({ disabled: false });
        }
        else {
            $(".addRemoveSubmit").prop({ disabled: true });
        }

    });

    $(".page-wrapper").on("change", ".pendingTraineeList", function () {
        var traineeList = "";
        var traineeCount = 0;

        $(".pendingTraineeList:checked").each(function () {
            var traineeId = $(this).data("trainee-id");
            if (traineeId != null && traineeId != undefined) {
                traineeList += traineeId + ",";
            }
            traineeCount += 1;
        });

        traineeList = traineeList.slice(0, -1);

        var pendingTraineesEditWrapper = $('.pending-trainees-edit-wrapper');

        if (traineeCount > 0) {
            $(".editActionBtn").prop({ disabled: false });
            if (pendingTraineesEditWrapper.length) {
                pendingTraineesEditWrapper.fadeIn(500);
            }
        }
        else {
            $(".editActionBtn").prop({ disabled: true });
            if (pendingTraineesEditWrapper.length) {
                pendingTraineesEditWrapper.fadeOut(500);
            }
        }

        $('.traineeCounter').text(traineeCount);
        $('.SelectedTraineeIds').val(traineeList);

        var selectAll = $('.select-all-pending-trainees');
        if (selectAll.length) {
            // if unselected we need to unselect the "select all checkbox" too
            if (!$(this).is(":checked")) {
                selectAll.prop('checked', false);
            }
            // if we have selected all checkboxes then we need to mark the "select all" checkbox as checked
            if ($('.pendingTraineeList').length === traineeCount) {
                selectAll.prop('checked', true);
            }
        }
    });

    // Trainee select
    $(".page-wrapper").on("change", ".groupTraineeList", function () {
        var traineeList = "";
        var connectionList = "";
        var traineeCount = 0;
        var selectedTraineeIds = $('.SelectedTraineeIds').first().val();
        var selectedTraineeIdsArr = selectedTraineeIds.split(',');
        selectedTraineeIdsArr = selectedTraineeIdsArr.filter(item => item);
        var selectedConnectionIds = $('.SelectedConnectionIds').first().val();
        var selectedConnectionIdsArr = selectedConnectionIds.split(',');
        selectedConnectionIdsArr = selectedConnectionIdsArr.filter(item => item);
        var traineeId = $(this).data("trainee-id");
        var connectionId = $(this).data("trainee-connectionid");
        
        if ($(this).is(':checked')) {
            if (traineeId != null && traineeId != undefined) {
                selectedTraineeIdsArr.push(traineeId);
            }
            if (connectionId != null & connectionId != undefined) {
                selectedConnectionIdsArr.push(connectionId)
            }

        }
        else {

            if (selectedTraineeIdsArr != null && selectedTraineeIdsArr != undefined) {
                var traineeIdIndex = selectedTraineeIdsArr.indexOf(traineeId);
                if (traineeIdIndex !== -1) {
                    selectedTraineeIdsArr.splice(traineeIdIndex, 1);
                }
            }

            if (selectedConnectionIdsArr != null && selectedConnectionIdsArr != undefined) {
                var connectionIdIndex = selectedConnectionIdsArr.indexOf(connectionId);
                if (connectionIdIndex !== -1) {
                    selectedTraineeIdsArr.splice(connectionIdIndex, 1);
                }

            }
        }

        selectedConnectionIdsArr = selectedConnectionIdsArr.filter(item => item);
        selectedTraineeIdsArr = selectedTraineeIdsArr.filter(item => item);

        selectedTraineeIdsArr.forEach((element) => {
            traineeList += element + ",";
            traineeCount += 1;
        });

        selectedConnectionIdsArr.forEach((element) => {
            connectionList += element + ",";
        });

        traineeList = traineeList.slice(0, -1);
        connectionList = connectionList.slice(0, -1);

        if (traineeCount > 0) {
            $(".editActionBtn").prop({
                disabled: false
            });
        } else {
            $(".editActionBtn").prop({
                disabled: true
            });
        }

        $('.traineeCounter').text(traineeCount);
        $('.SelectedTraineeIds').val(traineeList);
        SetPaginationLinks(traineeList);
        $('.SelectedConnectionIds').val(connectionList);
    });

    function SetPaginationLinks(traineeList) {
        $(".paginationLink").each(function () {
            var linkUrl = $(this).attr('href');
            linkUrl = removeURLParameter(linkUrl, "traineeList");
            //linkUrl = linkUrl.replace(/&traineeList\[\]=\d+/g, '')
            var newLink = linkUrl + '&traineeList=' + traineeList;
            $(this).attr("href", newLink);
        });
    }

    function removeURLParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }

    function removeURLParameters(url, ...parameters) {
        const parsed = new URL(url);
        parameters.forEach(e => parsed.searchParams.delete(e))
        return parsed.toString()
    }

    $('.page-wrapper').on("click", ".traineeGroupsModalBtn", function () {
        var traineeGroupBodyContent = $("#traineeGroupBodyContent");
        traineeGroupBodyContent.empty();

        var title = $(this).data("title");
        $("#traineeGroupTitle").text(title);

        var groups = $(this).data("groups");
        var groupsArr = groups.split(',');

        traineeGroupBodyContent.empty();
        groupsArr.forEach(function (group) {
            var traineeGroupBodyTemplate = $("#traineeGroupBodyTemplate");
            var traineeGroupBodyTemplateContent = traineeGroupBodyTemplate.html().replace("{GroupName}", group);

            traineeGroupBodyContent.append(traineeGroupBodyTemplateContent);
        });

        $("#TraineeeGroupsModal").modal("show");
    })

    $('.page-wrapper').on("click", ".settingsModalBtn", function () {
        var name = $(this).data("trainee-name");
        var id = $(this).data("trainee-id");
        var modal = $(this).data("modal");

        $('.SettingsContactId').val(id);

        $("#" + modal).modal("show");
    })

    $('.page-wrapper').on("click", ".GroupsModalBtn", function () {
        var title = $(this).data("title");
        var purpose = $(this).data("purpose");

        $(".SelectedPurpose").val(purpose);
        $("#GroupModalTitle").text(title);

        $("#GroupsModal").modal("show");
    })

    $('.page-wrapper').on("click", ".submitModal", function () {
        var modalTarget = "#" + $(this).data("modal-id");
        var btnTarget = "#" + $(this).data("submit-modal-form-id");

        if ($(btnTarget).valid()) { // validation passed
            $(modalTarget).modal('hide');
            $(btnTarget).submit();
        }
    });

    $('.page-wrapper').on("click", ".toggleContent", function () {
        var contentToShow = $("#" + $(this).attr("data-contentToShowId"))
        var contentToHide = $("#" + $(this).attr("data-contentToHideId"))

        contentToHide.fadeOut(500, function () {
            contentToShow.fadeIn(500, function () {
            });
        });
    });

    $('.page-wrapper').on("click", ".toggleGroupsEditMode", function () {
        var editMode = $("." + "editMode");
        var viewMode = $("." + "viewMode");
        var state = $(this).data("state-toggle");

        if (state === "edit") {
            if (viewMode.length === 0) {
                editMode.fadeIn(500);
                $("#IsGroupToggleOn").val("true");
            }
            else {
                viewMode.fadeOut(500, function () {
                    editMode.fadeIn(500);
                });
            }
        }
        else {
            $('.SelectedTraineeIds').val("");
            $('.SelectedConnectionIds').val("");
            SetPaginationLinks("");
            editMode.fadeOut(500, function () {
                $("#IsGroupToggleOn").val("false");
                viewMode.fadeIn(500, function () { });
            });
        }
    });

    $('.page-wrapper').on("click", ".toggleGroupsViewMode", function () {
        var editMode = $("." + "editMode")
        var viewMode = $("." + "viewMode")

        if (editMode) {
            editMode.fadeOut(500, function () {
                viewMode.fadeIn(500, function () {
                });
            });
        }
        else {
            viewMode.fadeIn(500, function () {
            });
        }
    });

    $('.page-wrapper').on("click", ".CancelRenameMode", function () {
        var parent = $(this).closest('.group');
        var editMode = parent.find('.editMode');
        var renameMode = parent.find(".renameMode");

        renameMode.fadeOut(500, function () {
            editMode.fadeIn(500, function () {
            });
        });
    });

    $('.page-wrapper').on("click", ".editGroupBtn", function () {
        var parent = $(this).closest('.group');
        var editMode = parent.find('.editGroup');
        var viewMode = parent.find(".viewGroup");
        var editModeBtn = parent.find('.editGroupBtnDiv');
        var saveModeBtn = parent.find('.saveGroupBtnDiv');

        viewMode.fadeOut(500, function () {
            editMode.fadeIn(500, function () {
            });
        });

        editModeBtn.fadeOut(500, function () {
            saveModeBtn.fadeIn(500, function () {
            });
        });
    });

    $('#AddUserSubmit').on('click', function (e) {
        e.preventDefault();
        $('#AddTPA').modal('hide');
        $('#AddUserForm').submit();
    });

    $('.eventBookingPage').on("click", "#AddDelegateBtn", function () {
        var AddBtn = $("#AddDelegateBtnWrapper");
        var AddContent = $("#AddDelegateContent");

        AddBtn.fadeOut(500, function () {
            AddContent.fadeIn(500, function () {
            });
        });
    });

    $('.eventBookingPage').on("click", "#EditDelegate_FilterBySupportOrganisationRate", function () {
        var SupportingOrg = $("#SupportingOrg");
        var inputs = document.getElementsByClassName('SupportingOrg');
        if ($(this).is(':checked')) {
            for (var i = 0; i < inputs.length; i++) {
                inputs[i].disabled = false;
            }
            SupportingOrg.fadeIn(500, function () {
            });
        } else {
            SupportingOrg.fadeOut(500, function () {
                for (var j = 0; j < inputs.length; j++) {
                    inputs[j].disabled = true;
                }
            });
        }
    });

    if ($(".multiselect-group").length > 0) {
        $(".buttons-source .move").on("click", function () {
            if ($(".form-multiselect.source").val().length > 0) {
                $(".form-multiselect.source > option:selected").each(function () {
                    if ($(".form-multiselect.target > option").length < 2) {
                        $(".form-multiselect.target").append(new Option($(this).text(), $(this).val()));
                        $(this).attr("disabled");
                        $(this).hide();
                    }
                    else {
                        return false;
                    }
                });

                multiselectUpdateHiddenField($(this).closest(".multiselect-group"));
            }
        });

        $(".buttons-target .remove").on("click", function () {
            if ($(".form-multiselect.target").val().length > 0) {
                $(".form-multiselect.target > option:selected").each(function () {
                    $(".form-multiselect.source > option[value='" + $(this).val() + "']").removeAttr("disabled").show();
                    $(this).remove();
                });
            }

            multiselectUpdateHiddenField($(this).closest(".multiselect-group"));
        });

        $(".buttons-target .up").on("click", function () {
            if ($(".form-multiselect.target").val().length == 1) {
                $(".form-multiselect.target option:selected").insertBefore($(".form-multiselect.target option:selected").prev());
                multiselectUpdateHiddenField($(this).closest(".multiselect-group"));
            }
        });

        $(".buttons-target .down").on("click", function () {
            if ($(".form-multiselect.target").val().length == 1) {
                $(".form-multiselect.target option:selected").insertAfter($(".form-multiselect.target option:selected").next());
                multiselectUpdateHiddenField($(this).closest(".multiselect-group"));
            }
        });

        var multiselectUpdateHiddenField = function (target) {
            var input = $(target).find('.multiselect-selectedValues');
            var selectedOps = $(target).find('.form-multiselect.target option');
            var selectedOpsStr = "";

            $(selectedOps).each(function () {
                if (selectedOpsStr != "") {
                    selectedOpsStr += ";"
                }

                selectedOpsStr += $(this).val();
            });

            $(input).val(selectedOpsStr);
        }
    }

    if ($.isFunction($(window).select2)) {
        if ($('select') !== undefined && $('select').length > 0) {
            $('select').each(function () {
                if (!$(this).is("[multiple]")) {
                    var _datalabel = $(this).data("default");
                    if (_datalabel === undefined || _datalabel === "") {
                        _datalabel = "Please select";
                    }

                    $(this).select2({
                        theme: 'bootstrap4',
                        placeholder: _datalabel,
                        minimumResultsForSearch: 15,
                    });
                }
            });
        }
    }

    $(".toggleMenu").on("click", function () {
        if (!$(this).hasClass("active")) {
            $(this).addClass("active");
            $("body").addClass("nav-is-visible");
            $(".dl-menu").addClass("dl-menuopen");
        }
        else {
            $(this).removeClass("active");
            $("body").removeClass("nav-is-visible");
            $(".dl-menu").removeClass("dl-menuopen");
        }
    });
});

export default Site;
